<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="false"
      unit="车辆"
      edit-title
      title="车辆详情"
      form-label-width="160px"
      id-key="CarId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border form1">
          <el-row>
            <el-col :span="12">
              <el-form-item label="归属机构" prop="DpId">
                {{data.DpName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号" prop="CarNo">
                {{data.CarNo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆颜色" prop="Color">
                {{data.Color}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购车日期" prop="BuyDate">
                {{$commonJs.toDateString(data.BuyDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆品牌" prop="Brand">
                {{data.Brand}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车系" prop="Series">
                {{data.Series}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车座数" prop="Seat">
                {{data.Seat}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资产类型" prop="AssetsType">
                <span v-if="data.AssetsType==0">自营</span>
                <span v-else-if="data.AssetsType==1">加盟</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆排量" prop="Volume">
                {{data.Volume}} L
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排挡类别" prop="GearType">
                <span v-if="data.GearType==0">自动</span>
                <span v-else-if="data.GearType==1">手动</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车架号" prop="Vin">
                {{data.Vin}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌颜色" prop="PlateColor">
                {{data.PlateColor}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发动机号" prop="EngineNo">
                {{data.EngineNo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="培训车型" prop="TrainCarType">
                {{data.TrainCarType}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="许可证号" prop="LicenceNo">
                {{data.LicenceNo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报废日期" prop="ScrapDate">
                {{$commonJs.toDateString(data.ScrapDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册日期" prop="RegisterDate">
                {{$commonJs.toDateString(data.RegisterDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="年审日期" prop="ReviewDate">
                {{$commonJs.toDateString(data.ReviewDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术等级" prop="Lv">
                {{data.Lv}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产厂家" prop="Manufactor">
                {{data.Manufactor}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="车辆图片" prop="PicUrls" :class="PicUrls.length?'file-form2':''">
                <template v-if="PicUrls.length">
                  <el-image class="viewImg" v-for="item in PicUrls" :key="item.url" :src="host + '/api' + item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                {{data.Remark}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        扩展信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆吨位" prop="Tonnage">
                {{data.Tonnage}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="燃料类型" prop="FuelType">
                {{data.FuelType}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆长度" prop="Length">
                {{data.Length===null?"":(data.Length+" mm")}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆宽度" prop="Width">
                {{data.Width===null?"":(data.Width+" mm")}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆高度" prop="Height">
                {{data.Height===null?"":(data.Height+" mm")}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="变速箱类型" prop="GearboxType">
                {{data.GearboxType}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="行驶证登记日期" prop="LicenseRegisterDate">
                {{$commonJs.toDateString(data.LicenseRegisterDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术等级有效期" prop="ExpireDate">
                {{$commonJs.toDateString(data.ExpireDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="道路教学车辆" prop="TeachCar">
                {{data.TeachCar}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副加速踏板" prop="SpeedPedal">
                {{data.SpeedPedal}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副离合器踏板" prop="ClutchPedal">
                {{data.ClutchPedal}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学车辆标识" prop="TeachLogo">
                {{data.TeachLogo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副后视镜" prop="Mirror">
                {{data.Mirror}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副制动踏板" prop="BrakePedal">
                {{data.BrakePedal}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="灭火器" prop="Extinguisher">
                {{data.Extinguisher}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他安全防护装置" prop="OtherDevice">
                {{data.OtherDevice}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="档位个数" prop="Gear">
                {{data.Gear}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="行驶证图片" prop="LicencePicUrls" :class="LicencePicUrls.length?'file-form2':''">
                <template v-if="LicencePicUrls.length">
                  <el-image class="viewImg" v-for="item in LicencePicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="技术证明" prop="TechPicUrls" :class="TechPicUrls.length?'file-form2':''">
                <template v-if="TechPicUrls.length">
                  <el-image class="viewImg" v-for="item in TechPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="车型证明" prop="CarPicUrls" :class="CarPicUrls.length?'file-form2':''">
                <template v-if="CarPicUrls.length">
                  <el-image class="viewImg" v-for="item in CarPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="购置证明" prop="BuyPicUrls" :class="BuyPicUrls.length?'file-form2':''">
                <template v-if="BuyPicUrls.length">
                  <el-image class="viewImg" v-for="item in BuyPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="出厂合格证或登记证明" prop="RegPicUrls" :class="RegPicUrls.length?'file-form2':''">
                <template v-if="RegPicUrls.length">
                  <el-image class="viewImg" v-for="item in RegPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="终端安装图片" prop="TermPicUrls" :class="TermPicUrls.length?'file-form2':''">
                <template v-if="TermPicUrls.length">
                  <el-image class="viewImg" v-for="item in TermPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="其他图片" prop="OtherPicUrls" :class="OtherPicUrls.length?'file-form2':''">
                <template v-if="OtherPicUrls.length">
                  <el-image class="viewImg" v-for="item in OtherPicUrls" :key="item.url" :src="host + '/api' +  item.url" :preview-src-list="[host + '/api' +  item.url]"></el-image>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <span v-if="data.ReviewTime">审批信息</span>
        <el-row class="row-border" v-if="data.ReviewTime">
          <el-col :span="12">
            <el-form-item label="审批人">
              {{data.ReviewUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批时间">
              {{data.ReviewTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批状态">
              <span v-if="data.Status==0">草稿</span>
              <span v-else-if="data.Status==1">待审批</span>
              <span v-else-if="data.Status==2">退回</span>
              <span v-else-if="data.Status==3">已审批</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="(data.Status==0||data.Status==2)&&data.ReviewTime">
            <el-form-item label="退回原因">
              {{data.ReviewRemark}}
            </el-form-item>
          </el-col>
        </el-row>
        备案信息
        <el-row class="row-border">
          <el-col :span="24">
            <el-form-item label="全国统一编码">
              {{data.CarCode}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案人">
              {{data.RecordUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案时间">
              {{data.RecordTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案状态">
              <span v-if="data.RecordStatus==0" style="color:#f11;">未备案</span>
              <span v-else-if="data.RecordStatus==1">备案中</span>
              <span v-else-if="data.RecordStatus==2" style="color:#f11;">备案失败</span>
              <span v-else-if="data.RecordStatus==3">备案通过</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.RecordRemark">
            <el-form-item label="备案备注">
              {{data.RecordRemark}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核状态">
              <span v-if="data.ExamStatus==0">待审核</span>
              <span v-else-if="data.ExamStatus==1">审核中</span>
              <span v-else-if="data.ExamStatus==2">审核失败</span>
              <span v-else-if="data.ExamStatus==3">审核成功</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核时间">
              {{data.ExamTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核意见">
              {{data.ExamRemark}}
            </el-form-item>
          </el-col>
        </el-row>
        其他信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="创建人">
              {{data.AddUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{data.AddTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改人">
              {{data.UpdateUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">
              {{data.UpdateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <!-- <el-button type="success" @click="pass" v-if="data.Status==1&&$permission.canReview()">通 过</el-button>
        <el-button type="danger" @click="back(1)" v-if="data.Status==1&&$permission.canReview()">退 回</el-button>
        <el-button type="danger" @click="back(2)" v-if="data.Status==3&&$permission.canReview()">撤销审批</el-button>
        <el-button @click="close">关 闭</el-button> -->
        <template v-if="$permission.canReview()&&(data.RecordStatus==0||data.RecordStatus==2)">
          <el-button type="success" @click="pass" v-if="data.Status==1">通 过</el-button>
          <el-button type="danger" @click="back(1)" v-if="data.Status==1">退 回</el-button>
          <el-button type="danger" @click="back(2)" v-if="data.Status==3">撤销审批</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn" ></return-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import returnDialog from "@/components/schoolmanage/dp/returnDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    returnDialog,
    treeSelect
  },
  data() {
    return {
      data: {
        CarId: 0,
        DpId: null,
        DpName: "",
        CarNo: "",
        Color: "",
        BuyDate: "",
        Brand: "",
        Series: "",
        Seat: null,
        AssetsType: null,
        Volume: null,
        GearType: null,
        Vin: "",
        PlateColor: "",
        EngineNo: "",
        TrainCarType: "",
        LicenceNo: "",
        ScrapDate: "",
        RegisterDate: "",
        ReviewDate: "",
        Lv: "",
        Manufactor: "",
        PicUrls: "",
        Remark: "",
        //------------
        Tonnage: null,
        FuelType: "",
        Length: null,
        Width: null,
        Height: null,
        GearboxType: "",
        LicenseRegisterDate: "",
        ExpireDate: "",
        TeachCar: "",
        SpeedPedal: "",
        ClutchPedal: "",
        TeachLogo: "",
        Mirror: "",
        BrakePedal: "",
        Extinguisher: "",
        OtherDevice: "",
        Gear: null,
        LicencePicUrls: "",
        TechPicUrls: "",
        CarPicUrls: "",
        BuyPicUrls: "",
        RegPicUrls: "",
        TermPicUrls: "",
        OtherPicUrls: "",
        Status: 0,
        CarCode: "",
        // ----------------
        ReviewUserName: "",
        ReviewTime: "",
        ReviewRemark: "",
        AddUserName: "",
        AddTime: "",
        UpdateUserName: "",
        UpdateTime: "",
        RecordStatus: 0,
        RecordTime: "",
        RecordUserName: "",
        RecordRemark: "",
        ExamStatus: 0,
        ExamTime: "",
        ExamRemark: ""
      },
      api: require("@/api/schoolmanage/car").default,
      BusinessRanges: [],
      PicUrls: [],
      LicencePicUrls: [],
      TechPicUrls: [],
      CarPicUrls: [],
      BuyPicUrls: [],
      RegPicUrls: [],
      TermPicUrls: [],
      OtherPicUrls: [],
      dpList: [],
      TreeData: [],
      disName: "",
      headers: { Authorization: "" },
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      backType: null,
      isMB: this.$store.state.isMB,
      rules: {
        DpId: [{ required: true, message: "请选择归属机构" }],
        FullName: [{ required: true, message: "请填写姓名" }],
        Sex: [{ required: true, message: "请选择性别" }],
        IdCard: [{ required: true, message: "请填写身份证号" }],
        Series: [{ required: true, message: "请填写车系" }],
        // DriveCarType: [{ required: true, message: "请选择准驾车型" }],
        // TeachCarType: [{ required: true, message: "请选择准教车型" }],
        BirthDate: [{ required: true, message: "请选择出生日期" }],
        Mobile: [{ required: true, message: "请填写手机号码" }],
        DriveNo: [{ required: true, message: "请填写驾驶证号" }],
        DriveDate: [{ required: true, message: "请选择驾驶证初领日期" }],
        InDate: [{ required: true, message: "请选择入职日期" }],
        InType: [{ required: true, message: "请选择任职类型" }],
        InStatus: [{ required: true, message: "请选择任职状态" }],
      },
    };
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {
      var urlArr = ["PicUrls","LicencePicUrls","TechPicUrls","CarPicUrls","BuyPicUrls","RegPicUrls","TermPicUrls","OtherPicUrls",];
      urlArr.forEach(e => {
        if(data[e]) {
          var arr = data[e].split(",");
          arr.forEach(n => {
            this[e].push({ url: n });
          })
        }
      });
    },
    onDetailsOpened(data) {
      this.onEditOpened(data);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass({ Id: this.data.CarId, Remark: "" }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success("操作成功");
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    back(t) {
      this.backType = t;
      this.$refs.returnDialog.open(t);
    },
    toReturn(data) {
      this.loading(true);
      if(this.backType==1) {
        this.api.back({ Id: this.data.CarId, Remark: data.Remark }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      } else {
        this.api.cancelReview({ Id: this.data.CarId, Remark: data.Remark }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      }
    },
    onSuccess(res,file,fileList) {
      
    },
    beforePhotoUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
    },
    picRemove(file) {
      
    },
    onSuccess2(res) {
      
    },
    picRemove2(file) {
      
    },
    toSave(type) {
      
    },
    onBeforeSave(data) {
      
    },
    onClosed() {
      this.PicUrls = [];
      this.LicencePicUrls = [];
      this.TechPicUrls = [];
      this.CarPicUrls = [];
      this.BuyPicUrls = [];
      this.RegPicUrls = [];
      this.TermPicUrls = [];
      this.OtherPicUrls = [];
    },
  },
};
</script>
<style lang="scss">
.viewImg{
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.file-form2{
  .el-form-item__label {
    line-height: 103px;
  }
}
.form1 {
  .el-form-item__label {
    width: 110px !important;
  }
  .el-form-item__content {
    margin-left: 110px !important;
  }
}
</style>